/**
 * Returns the longest option label string for a list of crop fields.
 * Use this to drive a CSS grid sizer element so the browser measures
 * the actual rendered text width rather than estimating it in pixels.
 */
export function longestCropFieldText(fields: { cropFieldName: string; cropVarietyName?: string | null }[]): string {
    if (!fields.length) return '';
    return fields.reduce((max, f) => (f.cropFieldName.length > max.length ? f.cropFieldName : max), '');
}
